import Api from '@/services/Api'

export default {
    // Obtener todos los kardex
    getAllTasasKardex() {
        return Api().get('tasas-kardex')
    },
    
    // Obtener compañías activas
    getCompanias() {
        return Api().get('tasas-kardex/companias')
    },
    
    // Obtener reportes principales
    getReportes() {
        return Api().get('tasas-kardex/reportes')
    },
    
    // Obtener conceptos existentes
    getConceptos() {
        return Api().get('tasas-kardex/conceptos')
    },
    
    // Obtener cuentas por compañía y fecha
    getCuentas(companiaId, fecha) {
        return Api().get(`tasas-kardex/cuentas/${companiaId}/${fecha}`)
    },
    
    // Crear nuevo kardex
    createTasasKardex(data) {
        return Api().post('tasas-kardex/create', data)
    },
    
    // Actualizar kardex
    updateTasasKardex(data) {
        return Api().put('tasas-kardex/update', data)
    },
    deleteTasasKardex(id) {
        return Api().delete(`tasas-kardex/delete/${id}`)
    }
}